import type { Language } from '@darkchat/types'

/**
 * タイプライター効果の表示速度設定
 */
export const TYPEWRITER_SPEED = {
  ja: {
    base: 30,        // 基本速度（ms）
    max: 300,        // 最大速度（ms）
    factor: 270      // 二次関数の係数
  },
  en: {
    base: 15,        // 基本速度（ms）
    max: 100,        // 最大速度（ms）
    factor: 85       // 二次関数の係数
  },
  default: 50        // デフォルト速度（言語未指定時）
} as const

/**
 * 言語と苦悶レベルに基づいてタイプライター速度を計算
 * 後半から急激に遅くなる二次関数的な増加
 * @param language 言語（'ja' または 'en'）
 * @param sufferingLevel 苦悶レベル（0-100）
 * @returns 表示速度（ミリ秒）
 */
export function calculateTypewriterSpeed(
  language: Language,
  sufferingLevel: number = 0
): number {
  // 対応していない言語の場合はデフォルト速度を返す
  if (language !== 'ja' && language !== 'en') {
    return TYPEWRITER_SPEED.default
  }

  const config = TYPEWRITER_SPEED[language]

  // 二次関数的な増加: base + (suffering / 100)^2 × factor
  // 苦悶が高いほど加速度的に遅くなる
  const normalizedSuffering = sufferingLevel / 100
  const calculatedSpeed = config.base + Math.pow(normalizedSuffering, 2) * config.factor
  return Math.min(calculatedSpeed, config.max)
}
